import { render, staticRenderFns } from "./PageForm.vue?vue&type=template&id=1a8b2f36"
import script from "./PageForm.vue?vue&type=script&lang=js"
export * from "./PageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports